import DateBox from 'devextreme-react/date-box';
import ScrollView from 'devextreme-react/scroll-view';
import TextBox from 'devextreme-react/text-box';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { cauHinhMaHocSinhApi } from '../../../api/cauhinh_mahocsinh_api';
import { HOCSINH_API_EDIT_MA_ENDPOINT, hocSinhApi } from '../../../api/hocsinh_api';
import { PrimaryButton } from '../../../components/editor/button';
import ComboboxDanToc from '../../../components/editor/cmb_dantoc';
import ComboboxGioiTinh from '../../../components/editor/cmb_gioitinh';
import ComboboxHe from '../../../components/editor/cmb_he';
import ComboboxHuyen from '../../../components/editor/cmb_huyen';
import ComboboxKhoi from '../../../components/editor/cmb_khoi';
import ComboboxLop from '../../../components/editor/cmb_lop';
import ComboboxNamHoc from '../../../components/editor/cmb_namhoc';
import ComboboxNguonBietToi from '../../../components/editor/cmb_nguon_biet_toi';
import ComboboxQuocTich from '../../../components/editor/cmb_quoctich';
import ComboboxTonGiao from '../../../components/editor/cmb_tongiao';
import { chienDichApi } from '../../../api/chienDichApi';
import NumberBox from "devextreme-react/number-box";
import { SelectBox } from 'devextreme-react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import ComboboxTinh from '../../../components/editor/cmb_tinh';
import ComboboxTruong from '../../../components/editor/cmb_truong';
import ComboboxXa from '../../../components/editor/cmb_xa';
import { InValidMessage } from '../../../components/editor/invalid_message';
import { FormGroup } from '../../../components/form-group';
import { HttpMethod, useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import { phuHuynhApi } from '../../../api/phuHuynhApi';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { quanHeGiaDinhApi } from '../../../api/quanHeGiaDinhApi';

const ProfileForm = ({ hocSinh, onSubmitSuccess, phuHuynh, registerResult, height }) => {
	const { translate } = useCommonContext();
	const [formData, setFormData] = useState({ ...hocSinh });
	const [isSaving, setIsSaving] = useState(false);
	const { dm_coso_id } = useSelector((x) => x.coSo);
	const { nam_hoc } = useSelector((x) => x.namHoc);
	const [ chiendichs, set_chiendichs] = useState([]);
	const { canAccessTo } = useCommonContext();

	const { register, trigger, errors } = useForm();
	// const [formData, setFormData] = useState({
	// 	...hocSinh,
	// 	ngay_sinh_timestamp: hocSinh.ngay_sinh ? new Date(hocSinh.ngay_sinh).getTime() : 0,
	// });
	useEffect(() => {
		handleReloadChienDichs();
	  }, [nam_hoc, dm_coso_id]);

	useEffect(() => {
		let _data = {
			...hocSinh,
			ngay_sinh_timestamp: hocSinh.ngay_sinh ? new Date(hocSinh.ngay_sinh).getTime() : 0,
		};
		if (hocSinh.id == 0 && (phuHuynh || registerResult)) {
			handleGetHocSinhData();
		} else {
			setFormData(_data);
		}
		
		
	}, [hocSinh, phuHuynh, registerResult]);

	const handleReloadChienDichs = async () => {
		const res = await chienDichApi.SelectByCoSo(dm_coso_id);
		if (res.is_success) {
			const _listData = res.data.filter(
			(y) => y.dm_coso_id == dm_coso_id
			);
			const _listData2 = _listData.filter(
			(y) => y.nam_hoc == nam_hoc
			);
			set_chiendichs(_listData2);
		}
	  };

	const handleGetHocSinhData = async () => {
		var result = registerResult;
		if(!registerResult || registerResult.id<=0){
			const ls = await phuHuynhApi.SelectLichSuDangKy(phuHuynh.id, dm_coso_id);
			if(ls.data.length>0){
				result = ls.data[0];
			}
		}
		
		if(result && result.id>0){
			var ts_form_register_result_id = result.id;

			const res = await formRegisterApi.SelecDetailList(dm_coso_id, result.dm_chiendich_id);
			let _data = {
				...hocSinh,
				ngay_sinh_timestamp: hocSinh.ngay_sinh ? new Date(hocSinh.ngay_sinh).getTime() : 0,
			};
			const details = res.data.filter(
				(y) => y.ts_form_register_result_id == ts_form_register_result_id
			);

			details.forEach(element => {
				switch (element.ts_form_editor_id) {
					case 2000:
						_data.ho_ten = element.value;
						break;
					case 2001:
						_data.dm_gioitinh_id = parseInt(element.value);
						break;
					case 2002:
						_data.ngay_sinh_timestamp = element.value? moment(element.value, 'DD/MM/YYYY').toDate().getTime(): 0;
						break;
					case 2003:
						_data.dm_quoctich_id = parseInt(element.value);
						break;
					case 2004:
						_data.dm_truong_id = parseInt(element.value);
						break;
					case 2005:
						_data.dm_khoi_id = parseInt(element.value);
						break;
					case 2006:
						_data.dm_he_id = parseInt(element.value);
						break;
					case 2007:
						_data.truong_hoc_cu = element.value;
						break;
					case 2008:
						_data.dm_nguonbiettoi_id = parseInt(element.value);
						break;
					case 2009:
						_data.nam_hoc = element.value;
						break;				
					case 2010:
						_data.dia_chi_tt = element.value;
						break;
					case 2011:
						_data.dia_chi_noi_sinh = element.value;
						break;
					case 2012:
						_data.que_quan = element.value;
						break;
					default:
						break;
				}
			});
			// console.log(_data, '_data');
			setFormData(_data);
		}
		
    }

	const saveQuanHeGiaDinh = async (ts_phuhuynh_id, ts_hocsinh_id) => {
		var result = registerResult;
		if (!registerResult || registerResult.id <= 0) {
			const ls = await phuHuynhApi.SelectLichSuDangKy(ts_phuhuynh_id, dm_coso_id);
			if (ls.data.length > 0) {
				result = ls.data[0];
			}

		}
		if (result && result.id > 0) {
			try {
				var dm_quanhe_id = 1;
				var dm_gioitinh_id = 1;
				if (ts_phuhuynh_id == result.ts_phuhuynh_me_id) {
					dm_quanhe_id = 2;
					dm_gioitinh_id = 2;
				}
				if (ts_phuhuynh_id == result.ts_phuhuynh_gh_id) {
					dm_quanhe_id = 3;
				}
				var ts_form_register_result_id = result.id;
				const res = await formRegisterApi.SelecDetailList(dm_coso_id, result.dm_chiendich_id);
				const details = res.data.filter(
					(y) => y.ts_form_register_result_id == ts_form_register_result_id
				);
				var name = "", email = "", dien_thoai = "", nghe_nghiep = "", noi_lam_viec = "", chung_minh_thu = "";
				switch (dm_quanhe_id) {
					case 1:
						details.forEach(element => {
							switch (element.ts_form_editor_id) {
								case 2013:
									name = element.value;
									break;
								case 2014:
									email = element.value
									break;
								case 2015:
									dien_thoai = element.value;
									break;
								case 2016:
									nghe_nghiep = element.value;
									break;
								case 2017:
									noi_lam_viec = element.value;
									break;
								case 2018:
									chung_minh_thu = element.value;
									break;
								default:
									break;
							}
						});
						break;
					case 2:
						details.forEach(element => {
							switch (element.ts_form_editor_id) {
								case 2019:
									name = element.value;
									break;
								case 2020:
									email = element.value
									break;
								case 2021:
									dien_thoai = element.value;
									break;
								case 2022:
									nghe_nghiep = element.value;
									break;
								case 2023:
									noi_lam_viec = element.value;
									break;
								case 2024:
									chung_minh_thu = element.value;
									break;
								default:
									break;
							}
						});
						break;
					case 3:
						details.forEach(element => {
							switch (element.ts_form_editor_id) {
								case 2025:
									name = element.value;
									break;
								case 2026:
									email = element.value
									break;
								case 2030:
									dien_thoai = element.value;
									break;
								case 2027:
									nghe_nghiep = element.value;
									break;
								case 2028:
									noi_lam_viec = element.value;
									break;
								case 2029:
									chung_minh_thu = element.value;
									break;
								default:
									break;
							}
						});
						break;

					default:
						break;
				}
				var quan_he = {
					ts_phuhuynh_id: ts_phuhuynh_id,
					ho_ten: name,
					dien_thoai: dien_thoai,
					email: email,
					dm_gioitinh_id: dm_gioitinh_id,
					dm_quanhe_id: dm_quanhe_id,
					chung_minh_thu: chung_minh_thu,
					nghe_nghiep: nghe_nghiep,
					noi_lam_viec: noi_lam_viec,
					ts_hocsinh_id: ts_hocsinh_id,
					dm_coso_id: dm_coso_id
				}
				await quanHeGiaDinhApi.Insert(quan_he);


			} catch (error) {

			}
		}else{
			console.log(phuHuynh);
			if(phuHuynh){
				var quan_he = {
					ts_phuhuynh_id: phuHuynh.id,
					ho_ten: phuHuynh.ho_ten,
					dien_thoai: phuHuynh.dien_thoai,
					email: phuHuynh.email,
					dm_gioitinh_id: phuHuynh.dm_gioitinh_id,
					dm_quanhe_id: phuHuynh.dm_quanhe_id,
					chung_minh_thu: phuHuynh.chung_minh_thu,
					nghe_nghiep: phuHuynh.nghe_nghiep,
					noi_lam_viec: phuHuynh.noi_lam_viec,
					ts_hocsinh_id: ts_hocsinh_id,
					dm_coso_id: dm_coso_id
				}
				await quanHeGiaDinhApi.Insert(quan_he);
			}
		}

	}

	const handleSaveChanges = async (datas) => {
		const formDataSubmit = {
			...formData,
			dm_coso_id: dm_coso_id,
			ngay_sinh_timestamp: formData.ngay_sinh_timestamp ? new Date(formData.ngay_sinh_timestamp).getTime() : 0,
			ngay_nhap_hoc_timestamp: formData.ngay_nhap_hoc_timestamp
				? new Date(formData.ngay_nhap_hoc_timestamp).getTime()
				: 0,
			nam_hoc: formData.nam_hoc == null ? nam_hoc : formData.nam_hoc,
			nam_nhap_hoc: formData.nam_nhap_hoc == null ? nam_hoc : formData.nam_nhap_hoc,
			// quoc_tich_id_nguoilienhe: formData.quoc_tich_id_nguoilienhe,
			// chung_minh_thu_nguoilienhe: formData.chung_minh_thu_nguoilienhe,
			// noi_cap_chung_minh_thu_nguoilienhe: formData.noi_cap_chung_minh_thu_nguoilienhe,
			// noi_lam_viec_nguoilienhe: formData.noi_lam_viec_nguoilienhe,
			// nghe_nghiep_nguoilienhe: formData.nghe_nghiep_nguoilienhe,
		};

		trigger().then(async (isValid) => {
			// var nam_hoc = (formData.nam_hoc == null || formData.namHoc == undefined) ? nam_hoc : formData.nam_hoc
			if (isValid) {
				if (formData.id > 0) {
					setIsSaving(true);
					if(dm_coso_id==1){
						const resOld = await hocSinhApi.Detail(formData.id, nam_hoc);
						const hsOld = resOld.data;
						if(hsOld.ma_hs != formData.ma_hs){
							const resExits = await hocSinhApi.SelectByMaHs(formData.ma_hs, dm_coso_id);
							console.log(resExits);
							if(resExits.data){
								showNotify({ text: translate("Mã học sinh đã tồn tại"), type: 'error' });
								setIsSaving(false);
								return;
							}
						}
					}
					console.log("ok");
					const res = await hocSinhApi.Update(formDataSubmit);
					setIsSaving(false);
					if (res.is_success) {
						showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
						onSubmitSuccess(formData.id);
					} else {
						showNotify({ text: res.message, type: 'error' });
					}
				} else {
					const resCauHinh = await cauHinhMaHocSinhApi.SelectByCoSo(dm_coso_id);
					if (resCauHinh.is_success) {
						if (resCauHinh.data.length > 0) {
							const filterByNamHoc = resCauHinh.data.filter((x) => x.nam_hoc == formDataSubmit.nam_hoc && x.is_active == true);
							if (filterByNamHoc != null && filterByNamHoc.length > 0) {
								var gioiHanTren = Math.pow(10, filterByNamHoc[0].so_kytu_tutang) - 1;
								if (filterByNamHoc[0].so_hientai >= 0 && filterByNamHoc[0].so_hientai <= gioiHanTren) {
									setIsSaving(true);
									const res = await hocSinhApi.Insert(formDataSubmit);
									setIsSaving(false);
									if (res.is_success) {
										try {
											if(registerResult!=null && registerResult.id>0){
												await formRegisterApi.UpdateResult(
													{
													  is_update_invite: registerResult.is_update_invite,
													  ts_hocsinh_id: res.data,
													  dm_chiendich_id: registerResult.dm_chiendich_id,
													  id: registerResult.id
													}
												  );
											}
										} catch (error) {
											
										}
																				
										if(phuHuynh && phuHuynh.id>0){
											await saveQuanHeGiaDinh(phuHuynh.id, res.data);
										}else{
											if(registerResult && registerResult.id>0){
												if(registerResult.ts_phuhuynh_id>0){
													await saveQuanHeGiaDinh(registerResult.ts_phuhuynh_id, res.data);
												}
												if(registerResult.ts_phuhuynh_me_id>0){
													await saveQuanHeGiaDinh(registerResult.ts_phuhuynh_me_id, res.data);
												}
												if(registerResult.ts_phuhuynh_gh_id>0){
													await saveQuanHeGiaDinh(registerResult.ts_phuhuynh_gh_id, res.data);
												}
											}
										}
										
										showNotify({ text: translate('Thêm mới thành công '), type: 'success' });
										onSubmitSuccess(res.data);
									} else {
										showNotify({ text: res.message, type: 'error' });
									}
								} else {
									showNotify({
										text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${formDataSubmit.nam_hoc} `),
										type: 'error',
									});
								}
							} else {
								showNotify({
									text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${formDataSubmit.nam_hoc} `),
									type: 'error',
								});
							}
						} else {
							showNotify({
								text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${formDataSubmit.nam_hoc} `),
								type: 'error',
							});
						}
					} else {
						showNotify({
							text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${formDataSubmit.nam_hoc} `),
							type: 'error',
						});
					}
				}
			}
		});
	};

	return (
		<div>
			<ScrollView height={height ?? window.innerHeight - 250}>
				<form className='ui' style={{ maxWidth: 1200 }}>
					<div className='row'>
					{canAccessTo(HOCSINH_API_EDIT_MA_ENDPOINT, HttpMethod.GET) && formData.id>0 && dm_coso_id == 1 && <div className='col-md-12'>
							<FormGroup label={translate('Mã học sinh')}>
								<TextBox
									stylingMode='outlined'
									value={formData.ma_hs}
									valueChangeEvent='keyup'
									onValueChanged={(e) => {
										if (e.event) {
											// setFormData({ ...formData, ho_ten: e.value });
											setFormData((prev) => ({ ...prev, ma_hs: e.value }));
											trigger('ma_hs');
										}
									}}
								/>
								<InValidMessage
									errors={errors}
									register={register({ required: true })}
									defaultValue={formData.ma_hs}
									message={translate('Vui lòng điền mã học sinh')}
									name={'ma_hs'}
								/>
							</FormGroup>
						</div>
					}
						<div className='col-md-12'>
							<div className='row'>
								<div className='col-md-4'>
									<FormGroup label={translate('Năm học')}>
										<ComboboxNamHoc
											width={'100%'}
											disabled={formData.is_edit_namhoc}
											value={formData.nam_hoc == null ? nam_hoc : formData.nam_hoc}
											onValueChanged={(value) => {
												// setFormData({ ...formData, nam_hoc: value });
												setFormData((prev) => ({ ...prev, nam_hoc: value || nam_hoc }));
												trigger('nam_hoc');
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ required: true })}
											defaultValue={formData.nam_hoc == null ? nam_hoc : formData.nam_hoc}
											message={translate('Vui lòng chọn năm học')}
											name={'nam_hoc'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Họ tên')}>
										<TextBox
											stylingMode='outlined'
											value={formData.ho_ten}
											valueChangeEvent='keyup'
											onValueChanged={(e) => {
												if (e.event) {
													// setFormData({ ...formData, ho_ten: e.value });
													setFormData((prev) => ({ ...prev, ho_ten: e.value }));
													trigger('ho_ten');
												}
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ required: true })}
											defaultValue={formData.ho_ten}
											message={translate('Vui lòng điền họ tên')}
											name={'ho_ten'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Họ tên EN')}>
										<TextBox
											stylingMode='outlined'
											value={formData.ho_ten_en}
											valueChangeEvent='keyup'
											onValueChanged={(e) => {
												if (e.event) {
													setFormData((prev) => ({ ...prev, ho_ten_en: e.value }));
													trigger('ho_ten_en');
												}
											}}
										/>
									</FormGroup>
								</div>
							</div>
						</div>
						<div className='col-md-12'>
							<div className='row'>
								<div className='col-md-4'>
									<FormGroup label={translate('Ngày sinh')}>
										<DateBox
											stylingMode='outlined'
											value={formData.ngay_sinh_timestamp || null}
											displayFormat={'dd/MM/yyyy'}
											onValueChanged={(e) => {
												if (e.event) {
													// setFormData({ ...formData, ngay_sinh_timestamp: e.value });
													setFormData((prev) => ({ ...prev, ngay_sinh_timestamp: e.value }));
													trigger('ngay_sinh_timestamp');
												}
											}}
											dm_coso_id={dm_coso_id}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 1 })}
											defaultValue={formData.ngay_sinh_timestamp}
											message={translate('Vui lòng điền ngày sinh')}
											name={'ngay_sinh_timestamp'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Quốc tịch')}>
										<ComboboxQuocTich
											value={formData.dm_quoctich_id == 0 || formData.dm_dantoc_id == null ? formData.dm_quoctich_id = 1 : formData.dm_quoctich_id}
											width='100%'
											onValueChanged={(value) => {
												// setFormData({ ...formData, dm_quoctich_id: value })
												setFormData((prev) => ({ ...prev, dm_quoctich_id: value }));
												trigger('dm_quoctich_id');
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0 })}
											defaultValue={formData.dm_quoctich_id}
											message={translate('Vui lòng chọn quốc tịch')}
											name={'dm_quoctich_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Dân tộc')}>
										<ComboboxDanToc
											value={formData.dm_dantoc_id == 0 || formData.dm_dantoc_id == null ? formData.dm_dantoc_id = 1 : formData.dm_dantoc_id}
											width='100%'
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_dantoc_id: value }));
												trigger('dm_dantoc_id');
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0 })}
											defaultValue={formData.dm_dantoc_id}
											message={translate('Vui lòng chọn dân tộc')}
											name={'dm_dantoc_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Tôn giáo')}>
										<ComboboxTonGiao
											value={formData.dm_tongiao_id == 0 || formData.dm_tongiao_id == null ? formData.dm_tongiao_id = 1 : formData.dm_tongiao_id}
											width='100%'
											onValueChanged={(value) => {
												// setFormData({ ...formData, dm_quoctich_id: value })
												setFormData((prev) => ({ ...prev, dm_tongiao_id: value }));
												trigger('dm_tongiao_id');
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Giới tính')}>
										<ComboboxGioiTinh
											value={formData.dm_gioitinh_id || 0}
											width='100%'
											onValueChanged={(value) => {
												// setFormData({ ...formData, dm_gioitinh_id: value })
												setFormData((prev) => ({ ...prev, dm_gioitinh_id: value }));
												trigger('dm_gioitinh_id');
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0, required: true })}
											defaultValue={formData.dm_gioitinh_id}
											message={translate('Vui lòng chọn giới tính')}
											name={'dm_gioitinh_id'}
										/>
									</FormGroup>
								</div>

								<div className='col-md-4'>
									<FormGroup label={translate('Ngày nhập học')}>
										<DateBox
											stylingMode='outlined'
											value={formData.ngay_nhap_hoc}
											displayFormat={'dd/MM/yyyy'}
											onValueChanged={(e) => {
												if (e.event) {
													setFormData((prev) => ({
														...prev,
														ngay_nhap_hoc: e.value != null ? moment(e.value).format('YYYY-MM-DD') : null,
													}));
													trigger('ngay_nhap_hoc');
												}
											}}
										/>
									</FormGroup>
								</div>


								<div className='col-md-4'>
									<FormGroup label={translate('Trường cũ')}>
										<TextBox
											value={formData.truong_hoc_cu}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, truong_hoc_cu: e.value })
												setFormData((prev) => ({ ...prev, truong_hoc_cu: e.value }));
											}}
										/>
									</FormGroup>
								</div>


								<div className='col-md-4'>
									<FormGroup label={translate('Nguồn biết tới')}>
										<ComboboxNguonBietToi
											width={'100%'}
											value={formData.dm_nguonbiettoi_id}
											onValueChanged={(value) => {
												// setFormData({ ...formData, dm_nguonbiettoi_id: value })
												setFormData((prev) => ({ ...prev, dm_nguonbiettoi_id: value }));
											}}
											dm_coso_id={dm_coso_id}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Chiến dịch')}>
										<SelectBox
											dataSource={chiendichs}
											displayExpr={'ten_chien_dich'}
											valueExpr={'id'}
											value={formData.dm_chiendich_id}
											stylingMode="outlined"
											width={'100%'}
											searchEnabled
											placeholder={translate('Chọn chiến dịch')}
											showClearButton={true}
											onValueChanged={(e) => {
												if (e.event) {
													setFormData((prev) => ({ ...prev, dm_chiendich_id: e.value }));
												};
											}}
										/>
									</FormGroup>
								</div>
							</div>
						</div>
						<div
							className='col-md-12'
							style={{
								paddingTop: 30,
								paddingBottom: 10,
								fontWeight: 'bold',
								borderBottom: '1px solid #ececec',
							}}
						>
							<p>{translate('THÔNG TIN ĐĂNG KÝ')}</p>
						</div>
						<div className='col-md-12'>
							<div className='row'>
								<div className='col-md-4'>
									<FormGroup label={translate('Chọn trường')}>
										<ComboboxTruong
											width='100%'
											value={formData.dm_truong_id}
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_truong_id: value }));
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0, required: true })}
											defaultValue={formData.dm_truong_id}
											message={translate('Vui lòng chọn trường')}
											name={'dm_truong_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Chọn khối')}>
										<ComboboxKhoi
											width='100%'
											value={formData.dm_khoi_id}
											dm_truong_id={formData.dm_truong_id}
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_khoi_id: value }));
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0, required: true })}
											defaultValue={formData.dm_khoi_id}
											message={translate('Vui lòng chọn khối')}
											name={'dm_khoi_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Chọn hệ')}>
										<ComboboxHe
											width='100%'
											value={formData.dm_he_id}
											dm_khoi_id={formData.dm_khoi_id}
											onValueChanged={(value) => {
												setFormData({ ...formData, dm_he_id: value });
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0, required: true })}
											defaultValue={formData.dm_he_id}
											message={translate('Vui lòng chọn hệ')}
											name={'dm_he_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Chọn lớp')}>
										<ComboboxLop
											width='100%'
											value={formData.dm_lop_id}
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_lop_id: value }));
											}}
											namHoc={formData.nam_hoc == null ? nam_hoc : formData.nam_hoc}
											dm_truong_id={formData.dm_truong_id}
											dm_khoi_id={formData.dm_khoi_id}
											dm_he_id={formData.dm_he_id}
										/>
										<InValidMessage
											errors={errors}
											register={register({ min: 0 })}
											defaultValue={formData.dm_lop_id}
											message={translate('Vui lòng chọn lớp')}
											name={'dm_lop_id'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Năm nhập học')}>
										<ComboboxNamHoc
											width={'100%'}
											value={formData.nam_nhap_hoc == null ? nam_hoc : formData.nam_nhap_hoc}
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, nam_nhap_hoc: value }));
												trigger('nam_nhap_hoc');
											}}
										/>
										<InValidMessage
											errors={errors}
											register={register({ required: true })}
											defaultValue={formData.nam_nhap_hoc == null ? nam_hoc : formData.nam_nhap_hoc}
											message={translate('Vui lòng chọn năm nhập học')}
											name={'nam_nhap_hoc'}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Ngày thi đầu vào dự kiến')}>
										<DateBox
											stylingMode='outlined'
											value={formData.ngaythi_dauvao_dukien}
											displayFormat={'dd/MM/yyyy'}
											onValueChanged={(e) => {
												if (e.event) {
													setFormData((prev) => ({
														...prev,
														ngaythi_dauvao_dukien: e.value != null ? moment(e.value).format('YYYY-MM-DD') : null,
													}));
													trigger('ngaythi_dauvao_dukien');
												}
											}}
										/>
									</FormGroup>
								</div>
							</div>
						</div>
						<div
							className='col-md-12'
							style={{
								paddingTop: 30,
								paddingBottom: 10,
								fontWeight: 'bold',
								borderBottom: '1px solid #ececec',
							}}
						>
							<p>{translate('ĐỊA CHỈ HỌC SINH')}</p>
						</div>
						<div className='col-md-12'>
							<div className='row'>
								<div className='col-md-4'>
									<FormGroup label={translate('Tỉnh thường trú')}>
										<ComboboxTinh
											value={formData.dm_tinh_id}
											width='100%'
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_tinh_id: value }));
											}}
										// onValueChanged={(value) => setFormData({ ...formData, dm_tinh_id: value })}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Huyện thường trú')}>
										<ComboboxHuyen
											value={formData.dm_huyen_id}
											width='100%'
											dm_tinh_id={formData.dm_tinh_id}
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_huyen_id: value }));
											}}
										// onValueChanged={(value) => setFormData({ ...formData, dm_huyen_id: value })}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Xã thường trú')}>
										<ComboboxXa
											value={formData.dm_xa_id}
											dm_huyen_id={formData.dm_huyen_id}
											width='100%'
											onValueChanged={(value) => {
												setFormData((prev) => ({ ...prev, dm_xa_id: value }));
											}}
										// onValueChanged={(value) => setFormData({ ...formData, dm_xa_id: value })}
										/>
									</FormGroup>
								</div>
								<div className='col-md-12'>
									<FormGroup label={translate('Địa chỉ thường trú')}>
										<TextBox
											stylingMode='outlined'
											value={formData.dia_chi_tt}
											// onValueChanged={(e) => {
											//     if (e.event) setFormData({ ...formData, dia_chi_tt: e.value })
											// }}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, dia_chi_tt: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-12'>
									<FormGroup label={translate('Nơi sinh')}>
										<TextBox
											value={formData.dia_chi_noi_sinh}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, dia_chi_noi_sinh: e.value })
												setFormData((prev) => ({ ...prev, dia_chi_noi_sinh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-12'>
									<FormGroup label={translate('Quê quán')}>
										<TextBox
											value={formData.que_quan}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, que_quan: e.value }));
											}}
										/>
									</FormGroup>
								</div>

								{/* <div className='col-md-4'>
									<FormGroup label={'Địa chỉ hiện tại'}>
										<TextBox
											stylingMode='outlined'
											value={formData.dia_chi_hientai}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, dia_chi_hientai: e.value }));
											}}
										/>
									</FormGroup>
								</div> */}
							</div>
						</div>
						<div
							className='col-md-12'
							style={{
								paddingTop: 30,
								paddingBottom: 10,
								fontWeight: 'bold',
								borderBottom: '1px solid #ececec',
							}}
						>

							<p>{translate('THÔNG TIN KHÁC')}</p>
						</div>
						<div className='col-md-12'>
							<div className='row'>
								<div className='col-md-4'>
									<FormGroup label={translate('Mã số BHXH')}>
										<TextBox
											width='100%'
											stylingMode='outlined'
											value={formData.ma_so_bhxh}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, ma_so_bhxh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Loại đăng ký')}>
										<TextBox
											width='100%'
											stylingMode='outlined'
											value={formData.loai_dang_ky_bhxh}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, loai_dang_ky_bhxh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Số tiền BHXH')}>
										<NumberBox
											width='100%'
											stylingMode='outlined'
											value={formData.so_tien_bhxh}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, so_tien_bhxh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Nơi đăng ký KCB ban đầu')}>
										<TextBox
											width='100%'
											stylingMode='outlined'
											value={formData.noi_dang_ky_kcb_bandau}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, noi_dang_ky_kcb_bandau: e.value || '' }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Đối tượng chính sách')}>
										<TextBox
											width='100%'
											stylingMode='outlined'
											value={formData.doi_tuong_chinh_sach}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, doi_tuong_chinh_sach: e.value || '' }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Mã định danh')}>
										<TextBox
											value={formData.ma_dinh_danh}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, ma_dinh_danh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Email học sinh')}>
										<TextBox
											value={formData.email_hocsinh}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, email_hocsinh: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('SĐT học sinh')}>
										<TextBox
											value={formData.dien_thoai_hocsinh}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, dien_thoai_hocsinh: e.value }));
											}}
										/>
									</FormGroup>
								</div>

								<div className='col-md-4'>
									<FormGroup label={translate('Sức khỏe')}>
										<TextBox
											value={formData.tt_suc_khoe}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, truong_hoc_cu: e.value })
												setFormData((prev) => ({ ...prev, tt_suc_khoe: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<FormGroup label={translate('Mã số BHYT')}>
										<TextBox
											width='100%'
											stylingMode='outlined'
											value={formData.ma_so_bhyt}
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, ma_so_bhyt: e.value }));
											}}
										/>
									</FormGroup>
								</div>
								<div className='col-md-4'>
									<div className='row'>
									<div className='col-md-6'>
									<FormGroup label={translate('Chiều cao')} >
										<TextBox
											value={formData.chieu_cao}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, truong_hoc_cu: e.value })
												setFormData((prev) => ({ ...prev, chieu_cao: e.value }));
											}}
										/>
									</FormGroup>
									</div>
									<div className='col-md-6'>
									<FormGroup label={translate('Cân nặng')}>
										<TextBox
											value={formData.can_nang}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, truong_hoc_cu: e.value })
												setFormData((prev) => ({ ...prev, can_nang: e.value }));
											}}
										/>
									</FormGroup>
									</div>
									</div>
								</div>
								{/* <div className='col-md-4'>
									<FormGroup label={translate('Cân nặng')}>
										<TextBox
											value={formData.can_nang}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												// if (e.event) setFormData({ ...formData, truong_hoc_cu: e.value })
												setFormData((prev) => ({ ...prev, can_nang: e.value }));
											}}
										/>
									</FormGroup>
								</div> */}
								<div className='col-md-4'>
									<FormGroup label={translate('Home')}>
									<SelectBox
									stylingMode='outlined'
									dataSource={[1,2,3,4]}
									value={formData.home}
									onValueChanged={(e) => {
										setFormData((prev) => ({ ...prev, home: e.value }));
									}}/>
									</FormGroup>
								</div>
								<div className='col-md-12'>
									<FormGroup label={translate('Ghi chú')}>
										<TextBox
											value={formData.ghi_chu}
											width='100%'
											stylingMode='outlined'
											onValueChanged={(e) => {
												setFormData((prev) => ({ ...prev, ghi_chu: e.value }));
											}}
										/>
									</FormGroup>
								</div>
							</div>
						</div>

					</div>
				</form>
			</ScrollView>
			<div className='row'>
				<div
					className='col-md-12'
					style={{
						paddingTop: 30,
						paddingBottom: 10,
						fontWeight: 'bold',
						borderBottom: '1px solid #ececec',
					}}
				>
					<PrimaryButton text={translate('Cập nhật')} onClick={handleSaveChanges} isLoading={isSaving} />
				</div>
			</div>
		</div>
	);
};

export default ProfileForm;
